import { toast } from 'sonner';

type TelegramDownloadFile = (
	params: { url: string; file_name: string },
	callback?: (accepted: boolean) => void,
) => void;

const REVOKE_OBJECT_URL_DELAY_MS = 1000;

function getTelegramDownloadFile(): TelegramDownloadFile | undefined {
	const webApp = window.Telegram?.WebApp as { downloadFile?: TelegramDownloadFile } | undefined;
	return webApp?.downloadFile;
}

async function fetchAuthenticatedBlob(url: string): Promise<Blob> {
	const response = await fetch(url, { credentials: 'include' });
	if (!response.ok) {
		throw new Error(`HTTP ${response.status}`);
	}
	return response.blob();
}

function revokeObjectUrlLater(objectUrl: string): void {
	window.setTimeout(() => {
		URL.revokeObjectURL(objectUrl);
	}, REVOKE_OBJECT_URL_DELAY_MS);
}

function saveBlobViaAnchor(objectUrl: string, fileName: string): void {
	const anchor = document.createElement('a');
	anchor.href = objectUrl;
	anchor.download = fileName;
	anchor.rel = 'noopener';
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();
}

async function tryTelegramDownload(objectUrl: string, fileName: string): Promise<boolean> {
	const tgDownload = getTelegramDownloadFile();
	if (!tgDownload) return false;

	try {
		await new Promise<void>((resolve, reject) => {
			try {
				tgDownload({ url: objectUrl, file_name: fileName }, accepted => {
					if (accepted) {
						resolve();
					} else {
						reject(new Error('download rejected'));
					}
				});
			} catch (error) {
				reject(error);
			}
		});
		return true;
	} catch {
		return false;
	}
}

async function saveBlobToDevice(blob: Blob, fileName: string): Promise<void> {
	const objectUrl = URL.createObjectURL(blob);
	try {
		const tgAccepted = await tryTelegramDownload(objectUrl, fileName);
		if (tgAccepted) {
			toast.success('Сохранение запущено');
			return;
		}

		saveBlobViaAnchor(objectUrl, fileName);
		toast.success('Фото сохранено');
	} finally {
		revokeObjectUrlLater(objectUrl);
	}
}

export async function downloadClientPhoto(url: string, fileName: string): Promise<void> {
	const blob = await fetchAuthenticatedBlob(url);
	await saveBlobToDevice(blob, fileName);
}
